import { render, staticRenderFns } from "./courseOrderList.vue?vue&type=template&id=27acf808&scoped=true&"
import script from "./courseOrderList.vue?vue&type=script&lang=js&"
export * from "./courseOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27acf808",
  null
  
)

export default component.exports